
import { Star } from 'lucide-react'

export function TestimoniosSection() {
  const testimonios = [
    {
      quote: "Hemos encontrado en la dra. Mónica un gran ser humano y una profesional comprometida y con gran empatía. Durante las sesiones con nuestro hijo ha utilizado herramientas que lo han ayudado a tenerle la confianza para comunicarle sus emociones logrando resultados muy positivos.",
      author: "Randall Brenes y Maria Paola Arango",
      role: "Padres",
      rating: 5
    },
    {
      quote: "Gracias al equipo de Neuro Peques, nuestra hija ha superado muchas de sus dificultades de aprendizaje. Su enfoque personalizado y el seguimiento constante han marcado la diferencia.",
      author: "Carlos Jiménez",
      role: "Padre de Valentina, 10 años",
      rating: 5
    }
  ]

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`h-6 w-6 ${i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
      />
    ))
  }

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Círculos decorativos más visibles */}
      <div className="absolute -top-20 -right-20 w-60 h-60 bg-neuro-green opacity-25 rounded-full hidden md:block"></div>
      <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-neuro-yellow opacity-25 rounded-full hidden md:block"></div>
      <div className="absolute bottom-40 right-20 w-40 h-40 bg-neuro-red opacity-20 rounded-full hidden md:block"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-neuro-dark-blue mb-6">
            Lo Que Dicen Nuestras Familias
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conoce las experiencias de padres que han confiado en nosotros para el desarrollo de sus hijos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {testimonios.map((testimonio, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105">
              <div className="text-6xl text-neuro-blue mb-6">"</div>
              <blockquote className="text-gray-700 text-lg italic mb-6">
                {testimonio.quote}
              </blockquote>
              <div className="border-t border-gray-200 pt-4">
                <p className="font-semibold text-neuro-dark-blue text-lg">{testimonio.author}</p>
                <p className="text-gray-600">{testimonio.role}</p>
              </div>
              <div className="flex mt-4">
                {renderStars(testimonio.rating)}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
